import ImportListProductDescriptionTab from './ImportListProductDescriptionTab'

export default ImportListProductDescriptionTab
